import Link from "next/link"

interface LinkItemsProps {
  path: string
  id: number
  name: string
}

const LinkItems = ({ path, id, name }: LinkItemsProps) => {
  return (
    <Link
      href={`/admin/${path}?id=${id}`}
      className="text-[#1677ff] cursor-pointer transition duration-300 hover:text-[#0b5ed7] hover:underline text-base"
    >
      {name}
    </Link>
  )
}

export default LinkItems
